import { Box, Button, Typography } from "@mui/material";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import style from "../RegListActionCard.module.css";
import FormInputText from "../../../Inputs/FormInputText";
import FormInputRTE from "../../../Inputs/FormInputRTE";
import FormInputTagField from "../../../Inputs/FormInputTagField";
import FormInputSwitch from "../../../Inputs/FormInputSwitch";
import { useDispatch } from "react-redux";
import { sendMail } from "../../../../state/workshopSlice";
import EmailIcon from "@mui/icons-material/Email";
import { MuiFileInput } from "mui-file-input";

const EmailRegisteredUsers = ({ show, workshop }) => {
  const dispatch = useDispatch();
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      subject: "",
      body: "",
      sendToRegistered: true,
      sendToWaitlist: false,
      extraEmails: "",
    },
    criteriaMode: "all",
    mode: "onChange",
  });

  const [attachment, setAttachment] = useState(undefined);

  const onSubmit = (data) => {
    //put everyone who is going to receive this email into an array of email addresses
    let recipients = [];
    if (data.sendToRegistered)
      recipients = recipients.concat(
        workshop.registrations?.map((r) => r.staff.mail)
      );
    if (data.sendToWaitlist)
      recipients = recipients.concat(
        workshop.waitlists?.map((r) => r.staff.mail)
      );

    if (data.extraEmails.length > 0)
      recipients = recipients.concat(data.extraEmails.split(","));

    const mail = {
      to: recipients,
      subject: data.subject,
      body: data.body,
      attachment: attachment,
    };
    dispatch(sendMail(workshop.workshopId, mail));
  };

  const onError = (data) => {
    console.error(data);
  };

  return (
    <Box className={`${style.container} ${!show && style.hidden}`}>
      <form>
        <Typography variant="h5">Email the workshop</Typography>
        <FormInputText
          name="subject"
          label="Subject"
          control={control}
          rules={{
            required: {
              value: true,
              message: "A subject is needed for the email",
            },
          }}
          error={errors.subject?.message}
        />
        <FormInputRTE
          name="body"
          label="Body"
          placeholder="Enter body of email..."
          control={control}
          rules={{
            required: {
              value: true,
              message: "Please enter something for the body of this message",
            },
          }}
          error={errors.body?.message}
        />
        <MuiFileInput
          multiple
          label="Attach file"
          placeholder="Select a file to attach to email"
          size="small"
          sx={{ backgroundColor: "white", margin: "0.5rem 0" }}
          value={attachment}
          onChange={(newFile) => {
            setAttachment(newFile);
          }}
          getInputText={(value) => {
            if (value) {
              let txt = value[0].name;
              if (txt.length > 35) return txt.slice(0, 35).concat("...");
              return value[0].name;
            }
          }}
        />

        <Box className={style.section}>
          <Typography variant="body1">
            Who do you want this message to go to
          </Typography>
          <Box sx={{ display: "flex" }}>
            <Box>
              <FormInputSwitch
                name="sendToRegistered"
                label={`Registered (${workshop?.registrations?.length})`}
                control={control}
              />
            </Box>
            <Box>
              <FormInputSwitch
                name="sendToWaitlist"
                label={`Waitlist (${workshop?.waitlists?.length})`}
                control={control}
              />
            </Box>
          </Box>
          <Box>
            <FormInputTagField
              name="extraEmails"
              label="Other recipients"
              control={control}
            />
          </Box>
        </Box>
        <Button
          variant="contained"
          onClick={(e) =>
            handleSubmit(
              onSubmit,
              onError
            )(e).catch((e) => {
              console.log("e", e);
            })
          }
          startIcon={<EmailIcon />}
        >
          Send Email
        </Button>
      </form>
    </Box>
  );
};

export default EmailRegisteredUsers;
